<template>
  <div class="HomePageLayout" ref="homePageLayout">
    <!-- <div class="head_system_notice" v-if="noticeList.length" @click="handleClickSlide(0)">
      <img src="@/assets/systemNotice/notice.png" alt="" />
      <img src="@/assets/systemNotice/notice.png" alt="" />
      <img src="@/assets/systemNotice/notice.png" alt="" />
      {{ noticeList[0].title }}
    </div>-->
    <div
      class="banner"
      v-if="$route.path !== '/design/design' && $route.name !== 'designParams' && showSwiper"
    >
      <div>
        <swiper ref="myPcSwiper" :options="swiperOption">
          <swiper-slide v-for="(item, index) in bannerData" :key="index">
            <div class="imgWrap">
              <template v-if="item.id === 0">
                <img class="pcImg" :src="item.pcImg">
                <a class="linkA lt" href="/newcomer-gift"></a>
                <a class="linkA rt" href="/products"></a>
              </template>
              <template v-else>
                <a :href="item.href">
                  <img class="pcImg" :src="item.pcImg">
                </a>
              </template>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div class="banner_mobile" ref="mobileBanner">
      <div v-if="showSwiper">
        <swiper ref="myMbSwiper" :options="swiperOption">
          <swiper-slide
            v-for="(item, index) in bannerData.filter(item => {
              return item.mbImg
            })"
            :key="index"
          >
            <div class="imgWrap">
              <template v-if="item.id === 0">
                <img class="pcImg" :src="item.mbImg">
                <a class="linkA tp" href="/newcomer-gift"></a>
                <a class="linkA bt" href="/products"></a>
              </template>
              <template v-else>
                <a :href="item.href">
                  <img class="pcImg" :src="item.mbImg">
                </a>
              </template>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div
      style="border-bottom: 1px solid #cccccc"
      v-show="$route.path !== '/design/design' && $route.name !== 'designParams'"
    >
      <div class="header">
        <img src="@/assets/logo.png" class="hover logo" @click="changRoute('首页', '/home')">
        <div class="rightWrap">
          <div class="tabBar">
            <a-menu mode="horizontal" :selected-keys="select">
              <a-menu-item key="productDesign" @click="changRoute('首页', '/products')">
                <a-popover
                  placement="bottomLeft"
                  :visible="productVisible"
                  :trigger="['hover']"
                  overlayClassName="productOverlayWrap"
                  @visibleChange="productVisibleChange"
                >
                  <template slot="content">
                    <div class="homeBasicWrap clearFix">
                      <div class="hbLeft">
                        <div class="lItemLt">
                          <div
                            class="lItem"
                            @click="changeCategory('')"
                          >{{ $t('homepage.allProducts') }}</div>
                        </div>
                        <div class="lItemLt">
                          <div
                            class="lItem"
                            @click="changeProductTag('hot')"
                            :title="$t('homepage.bestSeller')"
                          >
                            {{ $t('homepage.bestSeller') }}
                            <!-- <img class="rightIcon" src="@/assets/products/hot.png" /> -->
                            <div class="rightIconWrap hot">HOT</div>
                          </div>
                        </div>
                        <div class="lItemLt">
                          <div
                            class="lItem"
                            @click="changeProductTag('new')"
                            :title="$t('homepage.newArraivals')"
                          >
                            {{ $t('homepage.newArraivals') }}
                            <!-- <img class="rightIcon" src="@/assets/products/new_r.png" /> -->
                            <div class="rightIconWrap new">NEW</div>
                          </div>
                        </div>
                        <div class="lItemLt">
                          <div
                            class="lItem"
                            @click="$router.push('/products/special/special_offer')"
                            title="Special Offer"
                          >
                            Special Offer
                            <!-- <img class="rightIcon" src="@/assets/products/new_r.png" /> -->
                            <div class="rightIconWrap sale">SALE</div>
                          </div>
                        </div>
                        <div class="lItemLt">
                          <div class="lItem" @click="changeProductTag('usa')" title="Made in USA">
                            Made in USA
                            <div class="rightIconWrap usa">USA</div>
                          </div>
                        </div>
                        <div class="lItemLt">
                          <div
                            class="lItem"
                            @click="$router.push('/products/timeliness/1')"
                            title="Fast Fulfillment Zone"
                          >
                            Fast Fulfillment Zone
                            <div class="rightIconWrap fast">FAST</div>
                          </div>
                        </div>
                        <template v-if="getToken">
                          <div class="lineBox"></div>
                          <div class="lItemLt">
                            <div
                              class="lItem"
                              @click="$router.push('/products/favorites/1')"
                              title="My Favorites"
                            >My Favorites({{ favoritesNum }})</div>
                          </div>
                        </template>
                        <div class="lineBox"></div>
                        <div class="lItemLt">
                          <div class="lItem" @click="$router.push('/coupon')" title="Coupon">Coupon</div>
                          <div
                            class="lItem"
                            @click="$router.push('/freeSample')"
                            title="Free Sample Service"
                          >Free Sample Service</div>
                          <div
                            class="lItem"
                            @click="changeProductBrand('1')"
                            title="Branding Options"
                          >Branding Options</div>
                        </div>
                        <div class="lineBox"></div>
                        <!-- <div class="lItem" @click="changeLevel('premium')">
                          {{ $t('homepage.premiumProducts') }}
                        </div>
                        <div class="lItem" @click="changeLevel('economical')">
                          {{ $t('homepage.economicalProducts') }}
                        </div>-->
                        <div class="lItemLt" v-for="item in specialList" :key="item.id">
                          <div class="lItem" @click="changeSpecial(item.handle)" :title="item.name">
                            {{ item.name }}
                            <img
                              src="@/assets/homePage/hot.svg"
                              style="transform: translateY(-2px);"
                              v-if="item.is_hot === 1"
                            >
                          </div>
                        </div>
                        <!-- <div class="lineBox"></div> -->
                      </div>
                      <div
                        style="
                          display: flex;
                          flex-flow: row;
                          padding: 20px;
                          flex-wrap: wrap;
                          box-shadow: 1px 0px 0px 1px rgba(34, 36, 38, 0.15) inset;
                        "
                      >
                        <div
                          v-for="(item, index) in stockSkuCategoryList"
                          :key="index"
                          style="display: flex; flex-flow: column; width: 180px; cursor: pointer"
                          @click="changeCategory(item.handle)"
                        >
                          <span
                            style="font-size: 18px; font-weight: 600"
                            class="hoverItem"
                          >{{ item.en_name }}</span>
                          <div
                            v-for="(childItem, index) in item.children"
                            :key="index"
                            @click.stop="changeCategory(childItem.handle)"
                            style="cursor: pointer; margin-top: 10px"
                            class="hoverItem"
                          >{{ childItem.en_name }}</div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <span
                    class="tabTitle"
                    :class="{ on: productVisible }"
                    style="display: flex; flex-flow: row"
                  >
                    <span style="font-size: 20px; line-height: 72px">Products</span>
                    <a-icon
                      class="down-icon"
                      :type="productVisible ? 'up' : 'down'"
                      style="margin-top: 30px; margin-left: 5px"
                    />
                  </span>
                </a-popover>
              </a-menu-item>
              <a-menu-item key="globalWarehouse">
                <a-popover
                  placement="bottomLeft"
                  :visible="globalVisible"
                  :trigger="['hover']"
                  overlayClassName="productOverlayWrap"
                  @visibleChange="globalVisibleChange"
                >
                  <template slot="content">
                    <div class="homeBasicWrap clearFix auto">
                      <div class="hbLeft">
                        <div class="lItemLt">
                          <div class="lItem" @mouseover="madeInType = 1">
                            Made in USA
                            <img class="rightIcon" src="@/assets/products/icon_us.png" />
                          </div>
                        </div>
                        <div class="lItemLt">
                          <div class="lItem" @mouseover="madeInType = 2">
                            Made in UK
                            <img class="rightIcon" src="@/assets/products/icon_uk.png" />
                          </div>
                        </div>
                        <div class="lItemLt">
                          <div class="lItem" @mouseover="madeInType = 3">
                            Made in DE
                            <img class="rightIcon" src="@/assets/products/icon_de.png" />
                          </div>
                        </div>
                        <div class="lItemLt">
                          <div class="lItem" @mouseover="madeInType = 4">
                            Made in JP
                            <img class="rightIcon" src="@/assets/products/icon_jp.png" />
                          </div>
                        </div>
                        <div class="lItemLt">
                          <div class="lItem" @mouseover="madeInType = 5">
                            Made in CA
                            <img class="rightIcon" src="@/assets/products/icon_ca.png" />
                          </div>
                        </div>
                        <template v-if="getToken">
                          <div class="lineBox"></div>
                          <div class="lItemLt">
                            <div
                              class="lItem"
                              @click="$router.push('/products/favorites/1')"
                              title="My Favorites"
                            >My Favorites({{ favoritesNum }})</div>
                          </div>
                        </template>
                      </div>
                      <div style="overflow: hidden; width: 250px; padding: 10px 20px;">
                        <div
                          v-for="(item, index) in stockSkuCategoryList"
                          :key="index"
                          style="padding: 5px 0; cursor: pointer"
                          @click="changeHandle(item.handle)"
                          v-if="showRightMenuItem(item)"
                        >
                          <span
                            style="font-size: 18px; font-weight: 600"
                            class="hoverItem"
                          >{{ item.en_name }}</span>
                        </div>
                      </div>
                    </div>
                  </template>
                  <span
                    class="tabTitle"
                    :class="{ on: globalVisible }"
                    style="display: flex; flex-flow: row"
                  >
                    <span style="font-size: 20px; line-height: 72px">Global Warehouse</span>
                  </span>
                </a-popover>
              </a-menu-item>
              <a-menu-item key="integrations">
                <a-popover
                  placement="bottomLeft"
                  :trigger="['hover']"
                  overlayClassName="productOverlayWrap"
                >
                  <template slot="content">
                    <div class="howItWorkWrap" style="width: 180px;">
                      <a href="/shopify">Shopify</a>
                      <a href="/etsy">Etsy</a>
                      <a href="/wooCommerce">WooCommerce</a>
                      <a href="/shoplazza">Shoplazza</a>
                    </div>
                  </template>
                  <span class="tabTitle pod">Integrations</span>
                </a-popover>
              </a-menu-item>
              <a-menu-item key="pod" @click="changRoute('首页', '/how-it-work')">
                <a-popover
                  placement="bottomLeft"
                  :visible="servicesVisible || programVisible"
                  :trigger="['hover']"
                  overlayClassName="productOverlayWrap"
                  @visibleChange="servicesVisibleChange"
                >
                  <template slot="content">
                    <div class="howItWorkWrap">
                      <a href="/customService">Custom Service</a>
                      <a href="/bulkOrderService">Bulk Order Service</a>
                      <a href="/brandService">Brand Service</a>
                      <a href="/transfer">Transfer Order</a>
                      <a href="/freeSample">Free Sample Service</a>
                      <a href="/groupBuyingService">Group-buying Service</a>
                      <a href="/affiliate-program">
                        <a-popover
                          placement="right"
                          :visible="programVisible"
                          :trigger="['hover']"
                          overlayClassName="productOverlayWrap"
                          @visibleChange="programVisibleChange"
                        >
                          <template slot="content">
                            <div class="howItWorkWrap">
                              <a href="/affiliate-program">Affiliate Introduction</a>
                              <a href="/affiliate-lessons">Affiliate Lessons</a>
                            </div>
                          </template>
                          <span style="display: flex; justify-content: space-between;">
                            <span>Affiliate Program</span>
                            <a-icon type="right" style="font-size: 16px; align-self:center;"/>
                          </span>
                        </a-popover>
                      </a>
                      <a href="/how-it-work">How Printdoors Works</a>
                      <a href="/holiday">Festival Collection</a>
                      <a href="/dropshipping">Dropshipping</a>
                      <a href="/bulkShipping">Bulk Shipping</a>
                    </div>
                  </template>
                  <span class="tabTitle pod">Services</span>
                </a-popover>
              </a-menu-item>
              <a-menu-item key="helpcenter" @click="changRoute('首页', '/helpcenter')">
                <span class="tabTitle blog">Help center</span>
              </a-menu-item>
              <a-menu-item
                key="halloween"
                @click="changRoute('首页', '/activity/worldCup')"
              >
                <span class="tabTitle blog">
                  World Cup
                  <img src="@/assets/homePage/hot.svg" style="transform: translateY(-2px);">
                </span>
              </a-menu-item>
            </a-menu>
          </div>
          <div class="userName">
            <div class="leftWrap">
              <div>
                <a-select
                  v-model="cur"
                  style="margin-right: 10px; width: 85px !important;"
                  @change="curChange"
                  :filter-option="filterOption"
                  show-search
                >
                  <a-select-option v-for="item in curList" :key="item.value" :value="item.value">
                    {{
                    item.label
                    }}
                  </a-select-option>
                </a-select>
                <span v-if="info.username" class="cart-sp" @click="$router.push('/systemNotice')">
                  <img src="@/assets/viewsLayout/systemNotice.png" style="margin-right: 26px">
                  <div
                    class="badge-wrap"
                    v-if="systemNoticePolling && systemNoticePolling.user_unread_notices > 0"
                  >
                    <a-badge :count="systemNoticePolling.user_unread_notices"/>
                  </div>
                </span>
                <span v-if="info.username" class="cart-sp" @click="$router.push('/cart')">
                  <img src="@/assets/viewsLayout/cart.png" style="margin-right: 26px">
                  <div class="badge-wrap" v-if="+cartTotal > 0">
                    <a-badge :count="cartTotal"/>
                  </div>
                </span>
                <span class v-if="info.username">
                  <img src="@/assets/design/user.png" height="16px">
                </span>
                <span v-if="!info.username">
                  <a
                    @click="$router.push('/user/login')"
                    style="color: #fd7801; font-size: 20px; padding: 5px"
                  >
                    <a-icon type="user"/>Sign in
                  </a>
                  <a
                    @click="$router.push('/user/login?type=2')"
                    style="
                      color: #ffffff;
                      background: #fd7801;
                      font-size: 20px;
                      border-radius: 5px;
                      padding: 5px;
                      margin-left: 10px;
                    "
                  >
                    <a-icon type="user-add"/>Sign up
                  </a>
                </span>
                <a
                  class="ant-dropdown-link"
                  style="color: #4b9bdf;"
                  @click="e => e.preventDefault()"
                >
                  <span
                    style="padding-left: 10px; max-width: 210px; display: table-cell; text-overflow: ellipsis; overflow: hidden;"
                    @click="$router.push('/personal_center/guide')"
                  >{{ info.username }}</span>
                </a>
                <!-- <a-divider type="vertical" v-if="info.username" />
                <a @click="$router.push('/personal_center/guide')" v-if="info.username" style="color: #4b9bdf">{{
                  $t('generic.workbench')
                }}</a>-->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="header-mobile" ref="mobileHeader">
        <div class="h-left">
          <a-icon type="menu-unfold" @click="drawVisible = true"/>
          <img src="@/assets/logo.png" class="hover logo" @click="changRoute('首页', '/home')">
        </div>
        <div class="h-right">
          <span v-if="token">{{ info.username }}</span>
          <a-icon type="user" @click="$router.push('/user/login')"/>
          <a-icon type="user-add" @click="$router.push('/user/login?type=2')" v-if="!token"/>
        </div>
      </div>
    </div>
    <div class="content">
      <keep-alive :include="['']">
        <router-view/>
      </keep-alive>
    </div>
    <div
      class="footer"
      v-if="$route.path !== '/home/adSpecial' && $route.path !== '/home/blog' && $route.path !== '/home/blogDetail'"
    >
      <div class="footerWrap">
        <div class="ft-menu-wrap" style="align-self: flex-start">
          <img src="@/assets/logo.png">
          <div style="display: flex; margin-top: 20px;">
            <a class="link_icon" href="https://www.instagram.com/printdoorsofficial_/" target="_blank">
              <img src="@/assets/homePage/link1.png">
            </a>
            <a
              class="link_icon"
              href="https://www.linkedin.com/in/printdoors-739a31248/recent-activity/" target="_blank"
            >
              <img src="@/assets/homePage/link2.png">
            </a>
            <a class="link_icon" href="https://www.facebook.com/PrintDoors-107562432088833" target="_blank">
              <img src="@/assets/homePage/link3.png">
            </a>
            <a class="link_icon" href="https://wa.me/message/G3IACTI7FENKM1" target="_blank">
              <img src="@/assets/homePage/link4.png">
            </a>
            <a class="link_icon" href="https://www.youtube.com/channel/UCWJsGsIpVPvv_CLu2K-mYXw" target="_blank">
              <img src="@/assets/homePage/link5.svg">
            </a>
            <a class="link_icon" href="https://www.tiktok.com/@printdoors_printondemand" target="_blank">
              <img src="@/assets/homePage/link6.png">
            </a>
            <!-- <a class="link_icon" href="https://www.instagram.com/printdoorsoffical/ target="_blank""
              ><img src="@/assets/homePage/link7.png"
            /></a>-->
            <a class="link_icon" href="https://t.me/+chU4s7bUaFEwYWVl" target="_blank">
              <img src="@/assets/homePage/link8.png">
            </a>
          </div>
        </div>
        <div class="ft-menu-wrap" style="align-self: flex-start">
          <a>About Printdoors</a>
          <a href="/about_us">Our Story</a>
          <a href="/contact_us">Contact Us</a>
          <a href="/affiliate-program">Affiliate Program</a>
        </div>
        <div class="ft-menu-wrap" style="align-self: flex-start">
          <a>Resources</a>
          <a href="/refund_policy">Return Policy</a>
          <a href="/privacy_policy">Privacy Policy</a>
          <a href="/timeliness">Fast Fulfillment Zone Policy</a>
          <a href="/terms_of_service">Terms of Service</a>
          <a href="/copyright_notice">Copyright Notice</a>
          <a href="/shipping">Shipping</a>
        </div>
        <div class="ft-menu-wrap" style="align-self: flex-start">
          <a>Sell with Printdoors</a>
          <a href="/print_on_demand">Print On Demand</a>
          <a href="/how-it-work">How It Work</a>
          <a href="/helpcenter">Help Center</a>
          <a href="https://www.printdoors.com/blog/" target="_blank">Technical Blog</a>
          <a href="https://www.printdoors.com/faq/" target="_blank">Information Based Blog</a>
        </div>
      </div>
      <a-divider></a-divider>
      <div class="footerWrap">
        <div>
          <div style="font-size: 14px; font-weight: 700; margin-bottom: 10px">We deliver with:</div>
          <img
            src="@/assets/homePage/footer/1.png"
            height="40"
            style="margin-right: 10px"
            alt="best custom hoodie website"
            title="best custom hoodie website"
          >
          <img
            src="@/assets/homePage/footer/2.png"
            height="40"
            style="margin-right: 10px"
            alt="personalised print"
            title="personalised print"
          >

          <img
            src="@/assets/homePage/footer/3.png"
            height="40"
            style="margin-right: 10px"
            alt="dropship t shirt"
            title="dropship t shirt"
          >

          <img
            src="@/assets/homePage/footer/4.png"
            height="40"
            style="margin-right: 10px"
            alt="printed gifts"
            title="printed gifts"
          >
        </div>
        <div>
          <div
            style="font-size: 14px; font-weight: 700; margin-bottom: 15px"
          >Payment methods we accpet:</div>
          <img
            src="@/assets/homePage/footer/5.png"
            height="28"
            style="margin-right: 10px"
            alt="what is print on demand"
            title="what is print on demand"
          >
          <img
            src="@/assets/homePage/footer/6.png"
            height="28"
            style="margin-right: 10px"
            alt="print on demand business"
            title="print on demand business"
          >
          <img
            src="@/assets/homePage/footer/7.png"
            height="28"
            style="margin-right: 10px"
            alt="printed mouse pad"
            title="printed mouse pad"
          >
          <img
            src="@/assets/homePage/footer/8.png"
            height="28"
            style="margin-right: 10px"
            alt="print on demand services"
            title="print on demand services"
          >
          <img
            src="@/assets/homePage/footer/9.png"
            height="28"
            style="margin-right: 10px"
            alt="printdoors custom printing"
            title="printdoors custom printing"
          >
          <img
            src="@/assets/homePage/footer/10.png"
            height="28"
            style="margin-right:  10px"
            alt="cheapest print on demand"
            title="cheapest print on demand"
          >
          <!-- <img
            src="@/assets/homePage/footer/11.png"
            height="28"
            style="margin-right: 10px"
            alt="stripe"
            title="stripe"
          />-->
        </div>
        <div
          class="copyrightWrap"
        >© 2022 printdoors, powered by printdoors group, All rights reserved.</div>
      </div>
    </div>
    <div class="footer-mobile" ref="footerMobile">
      <img src="@/assets/logo.png" class="hover logo" @click="changRoute('首页', '/home')">
      <p>We deliver with</p>
      <img src="@/assets/homePage/footer/2.mobile.png" alt>
      <p>Payment methods we accpet</p>
      <img src="@/assets/homePage/footer/1.mobile.png" alt>
      <a-menu mode="inline" :inlineCollapsed="false" @click="handleClick" style="text-align: left">
        <a-sub-menu key="1" title="About Printdoors">
          <a-menu-item key="/about_us">Our Story</a-menu-item>
          <a-menu-item key="/contact_us">Contact Us</a-menu-item>
          <a-menu-item key="/affiliate-program">Affiliate Program</a-menu-item>
        </a-sub-menu>
        <a-sub-menu key="2" title="Integrations">
          <a-menu-item key="/shopify">Shopify</a-menu-item>
          <a-menu-item key="/etsy">Etsy</a-menu-item>
          <a-menu-item key="/wooCommerce">WooCommerce</a-menu-item>
          <a-menu-item key="/shoplazza">Shoplazza</a-menu-item>
        </a-sub-menu>
        <a-sub-menu key="3" title="Resources">
          <a-menu-item key="/refund_policy">Return Policy</a-menu-item>
          <a-menu-item key="/privacy_policy">Rrivacy Policy</a-menu-item>
          <a-menu-item key="/timeliness">Fast Fulfillment Zone Policy</a-menu-item>
          <a-menu-item key="/terms_of_service">Terms of Service</a-menu-item>
        </a-sub-menu>
        <a-sub-menu key="4" title="Sell with Printdoors">
          <a-menu-item key="/print_on_demand">Print On Demand</a-menu-item>
          <a-menu-item key="/how-it-work">How It Work</a-menu-item>
          <a-menu-item key="/helpcenter">Help Center</a-menu-item>
          <a-menu-item key="https://www.printdoors.com/blog/">Technical Blog</a-menu-item>
          <a-menu-item key="https://www.printdoors.com/faq/">Information Based Blog</a-menu-item>
        </a-sub-menu>
      </a-menu>
    </div>

    <Draw
      :visible="drawVisible"
      @onclose="drawVisible = false"
      :stockSkuCategoryList="stockSkuCategoryList"
    />
    <a-modal
      title="Notice"
      :visible="visible"
      @cancel="
        () => {
          visible = false
        }
      "
      width="1000px"
      :footer="null"
      :getContainer="() => $refs.homePageLayout"
    >
      <div class="notice_detail">
        <div
          class="title"
        >{{ noticeData.title || 'Introducing Exciting Brand Value-Added Services on PrintDoors' }}</div>
        <div class="created_time">{{ noticeData.created_at }}</div>
        <div class="autoWrap">
          <div v-html="noticeData.desc" class="desc ql-editor"></div>
        </div>
        <div class="tc">
          <a-button @click="goDetail(noticeData.id)" type="primary">View more</a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import '@/views/bulletin/components/index.less'
import './viewsLayoutStyle/homePageLayout.less'
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import { getFrontendNoticeList, viewNotice, getSpecial } from '@/api/homePage/index'
import { getStockSkuCategory } from '@/api/products'
import Draw from './components/draw'
import { curList } from '@/utils/const'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

// ========== 缓存配置区域 ==========
// ！注意！后台更新 special 或 category 数据时，手动修改下面的版本号即可让用户重新拉取数据
const CACHE_VERSION = 'v5' // 后台数据更新后改成 v2、v3...

const SPECIAL_CACHE_KEY = `special_list_cache_${CACHE_VERSION}`
const SPECIAL_CACHE_TIME_KEY = `special_list_cache_time_${CACHE_VERSION}`
const CATEGORY_CACHE_KEY = `stock_sku_category_cache_${CACHE_VERSION}`
const CATEGORY_CACHE_TIME_KEY = `stock_sku_category_cache_time_${CACHE_VERSION}`
const ONE_MONTH = 30 * 24 * 60 * 60 * 1000

export default {
  name: 'HomePageLayout',
  data() {
    return {
      visible: false,
      madeInType: 1,
      showSwiper: true,
      activeBar: '首页',
      whiteList: [
        '/brandService',
        '/dropshipping',
        '/bulkShipping',
        '/groupBuyingService',
        '/freeSample',
        '/bulkOrderService',
        '/vnvip',
        '/about_us'
      ],
      drawVisible: false,
      productVisible: false,
      globalVisible: false,
      howItWorkVisible: false,
      programVisible: false,
      servicesVisible: false,
      stockSkuCategoryList: [],
      specialList: [],
      select: [],
      noticeList: [],
      noticeData: {},
      noticeIndex: 0,
      curList: curList,
      bannerData: [
        // {
        //   id: 11,
        //   pcImg: require('../assets/pcBanner11.png'),
        //   mbImg: require('../assets/mbBanner11.png'),
        //   href: '/activity/uniqueLove'
        // },
        // {
        //   id: 20,
        //   pcImg: require('../assets/pcBanner10.png'),
        //   mbImg: require('../assets/mbBanner10.png'),
        //   href: '/activity/customChristmas'
        // },
        // {
        //   id: 14,
        //   pcImg: require('../assets/pcBanner14.png'),
        //   mbImg: require('../assets/mbBanner14.png'),
        //   href: '/activity/motherIsDay'
        // },
        // {
        //   id: 2,
        //   pcImg: require('../assets/pcBanner6.png'),
        //   mbImg: require('../assets/mbBanner6.png'),
        //   href: '/activity/fatherIsDay'
        // },
        // {
        //   id: 6,
        //   pcImg: require('../assets/pcBanner20.png'),
        //   mbImg: require('../assets/mbBanner20.png'),
        //   href: '/activity/halloween'
        // },
        // {
        //   id: 7,
        //   pcImg: require('../assets/pcBanner17.png'),
        //   mbImg: require('../assets/mbBanner17.png'),
        //   href: '/activity/bestSellersForSummer'
        // },
        // {
        //   id: 13,
        //   pcImg: require('../assets/pcBanner13.png'),
        //   mbImg: require('../assets/mbBanner13.png'),
        //   href: '/activity/easterGiftZone'
        // },
        {
          id: 19,
          pcImg: require('../assets/pcBanner19.png'),
          mbImg: require('../assets/mbBanner19.png'),
          href: '/products/tag/usa'
        },
        {
          id: 16,
          pcImg: require('../assets/pcBanner16.png'),
          mbImg: require('../assets/mbBanner16.png'),
          href: '/products/timeliness/1'
        },
        {
          id: 0,
          pcImg: require('../assets/pcBanner1.jpg'),
          mbImg: require('../assets/mbBanner1.png')
        },
        // {
        //   id: 10,
        //   pcImg: require('../assets/pcBanner13.png'),
        //   mbImg: require('../assets/mbBanner13.png'),
        //   href: '/activity/easterGiftZone'
        // },
        // {
        //   id: 12,
        //   pcImg: require('../assets/pcBanner12.png'),
        //   mbImg: require('../assets/mbBanner12.png'),
        //   href: '/activity/stPatrickIsDay'
        // },
        {
          id: 13,
          pcImg: require('../assets/christmas/worldCup/worldCupBannerPc.png'),
          mbImg: require('../assets/christmas/worldCup/worldCupBannerMb.png'),
          href: '/activity/worldCup'
        },
        // {
        //   id: 14,
        //   pcImg: require('../assets/pcBanner15.png'),
        //   mbImg: require('../assets/mbBanner15.png'),
        //   href: '/activity/graduationSale'
        // },
        // {
        //   id: 1,
        //   pcImg: require('../assets/pcBanner2.png'),
        //   mbImg: require('../assets/mbBanner2.png'),
        //   href: '/activity/bestSellersForSummer'
        // },
        // {
        //   id: 2,
        //   pcImg: require('../assets/pcBanner4.png'),
        //   href: '/activity/graduationSale'
        // },
        // {
        //   id: 3,
        //   pcImg: require('../assets/pcBanner5.png'),
        //   mbImg: require('../assets/mbBanner5.png'),
        //   href: '/activity/allOverPrint'
        // },
        // {
        //   id: 5,
        //   pcImg: require('../assets/pcBanner7.png'),
        //   mbImg: require('../assets/mbBanner7.png'),
        //   href: '/activity/metalSignCustom'
        // }
        // {
        //   id: 6,
        //   pcImg: require('../assets/pcBanner8.png'),
        //   mbImg: require('../assets/mbBanner8.png'),
        //   href: '/activity/hawaiianBeachStyle'
        // }
        // {
        //   id: 7,
        //   pcImg: require('../assets/pcBanner9.png'),
        //   mbImg: require('../assets/mbBanner9.png'),
        //   href: '/activity/halloweenCustomization'
        // }
      ],
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        loop: true
      }
    }
  },
  components: { Draw, Swiper, SwiperSlide },
  methods: {
    ...mapActions(['Logout', 'getCartData', 'GetCurList', 'GetRate', 'GetSystemNoticePolling', 'GetFavoritesNum']),
    ...mapMutations({
      setHotWords: 'SET_HOT_WORDS',
      setCur: 'SET_CUR'
    }),
    // 获取特殊列表（带缓存，有效期一个月）
    getSpecialList() {
      const cachedData = localStorage.getItem(SPECIAL_CACHE_KEY)
      const cacheTime = localStorage.getItem(SPECIAL_CACHE_TIME_KEY)

      if (cachedData && cacheTime && (Date.now() - parseInt(cacheTime)) < ONE_MONTH) {
        this.specialList = JSON.parse(cachedData)
      } else {
        getSpecial().then(res => {
          this.specialList = res.data
          localStorage.setItem(SPECIAL_CACHE_KEY, JSON.stringify(res.data))
          localStorage.setItem(SPECIAL_CACHE_TIME_KEY, Date.now().toString())
        }).catch(err => {
          console.error('获取特殊列表失败:', err)
        })
      }
    },

    // 获取分类列表（带缓存，有效期一个月）
    getStockSkuCategoryList() {
      const cachedData = localStorage.getItem(CATEGORY_CACHE_KEY)
      const cacheTime = localStorage.getItem(CATEGORY_CACHE_TIME_KEY)

      if (cachedData && cacheTime && (Date.now() - parseInt(cacheTime)) < ONE_MONTH) {
        this.stockSkuCategoryList = JSON.parse(cachedData)
        // 处理分类数据（只显示二级分类）
        this.processCategoryData()
      } else {
        getStockSkuCategory().then(res => {
          this.stockSkuCategoryList = res.data
          localStorage.setItem(CATEGORY_CACHE_KEY, JSON.stringify(res.data))
          localStorage.setItem(CATEGORY_CACHE_TIME_KEY, Date.now().toString())
          this.processCategoryData()
        }).catch(err => {
          console.error('获取分类列表失败:', err)
        })
      }
    },

    // 处理分类数据（只显示二级分类）
    processCategoryData() {
      this.stockSkuCategoryList.forEach(item => {
        if (item.children) {
          item.children.forEach(child_item => {
            child_item.children = []
          })
        }
      })
    },

    // 清除所有缓存（可选，用于调试或强制刷新）
    clearAllCache() {
      localStorage.removeItem(SPECIAL_CACHE_KEY)
      localStorage.removeItem(SPECIAL_CACHE_TIME_KEY)
      localStorage.removeItem(CATEGORY_CACHE_KEY)
      localStorage.removeItem(CATEGORY_CACHE_TIME_KEY)
      console.log('所有缓存已清除')
      // 重新加载数据
      this.getSpecialList()
      this.getStockSkuCategoryList()
    },

    mobileCss() {
      this.showSwiper = false
      const fullPath = this.$route.fullPath
      if (
        fullPath === '/activity/customChristmas' ||
        fullPath === '/customService' ||
        fullPath === '/brandService' ||
        fullPath === '/dropshipping' ||
        fullPath === '/bulkShipping' ||
        fullPath === '/groupBuyingService' ||
        fullPath === '/freeSample' ||
        fullPath === '/activity/uniqueLove' ||
        fullPath === '/vnvip' ||
        fullPath === '/bulkOrderService' ||
        fullPath === '/activity/uniqueLove' ||
        fullPath === '/activity/easterGiftZone' ||
        fullPath === '/activity/MotherIsDay' ||
        fullPath === '/activity/HalloweenParty' ||
        fullPath === '/about_us'
      ) {
        this.$nextTick(() => {
          // const mobileBanner = this.$refs.mobileBanner
          // const mobileHeader = this.$refs.mobileHeader
          // const footerMobile = this.$refs.footerMobile
          const homePageLayout = this.$refs.homePageLayout
          // if (mobileBanner) {
          //   mobileBanner.style.minWidth = this.whiteList.indexOf(fullPath) >= 0 ? '1440px' : '1514px'
          // }
          // if (mobileHeader) {
          //   mobileHeader.style.minWidth = this.whiteList.indexOf(fullPath) >= 0 ? '1440px' : '1514px'
          // }
          // if (footerMobile) {
          //   footerMobile.style.minWidth = this.whiteList.indexOf(fullPath) >= 0 ? '1440px' : '1514px'
          // }
          if (homePageLayout) {
            if (this.whiteList.indexOf(fullPath) >= 0) {
              homePageLayout.style.minWidth = '1440px'
            } else if (fullPath === '/activity/easterGiftZone') {
              homePageLayout.style.minWidth = '1643px'
            } else if (fullPath === '/activity/HalloweenParty') {
              homePageLayout.style.minWidth = '1698px'
            } else {
              homePageLayout.style.minWidth = '1514px'
            }
          }
          setTimeout(() => {
            this.showSwiper = true
          }, 500)
        })
      } else {
        this.$nextTick(() => {
          const mobileBanner = this.$refs.mobileBanner
          const mobileHeader = this.$refs.mobileHeader
          const footerMobile = this.$refs.footerMobile
          if (mobileBanner) {
            mobileBanner.style.minWidth = 'auto'
          }
          if (mobileHeader) {
            mobileHeader.style.minWidth = 'auto'
          }
          if (footerMobile) {
            footerMobile.style.minWidth = 'auto'
          }
          setTimeout(() => {
            this.showSwiper = true
          }, 500)
        })
      }
    },
    handleClick(val) {
      console.log(val)
      if (val.key === 'https://www.printdoors.com/blog/' || val.key === 'https://www.printdoors.com/faq/') {
        window.open(val.key, '_blank')
      } else {
        this.$router.push(val.key)
      }
    },
    productVisibleChange(val) {
      this.productVisible = val
    },
    globalVisibleChange(val) {
      this.globalVisible = val
    },
    howItWorkVisibleChange(val) {
      this.howItWorkVisible = val
    },
    programVisibleChange(val) {
      this.programVisible = val
    },
    servicesVisibleChange(val) {
      this.servicesVisible = val
    },
    handleClickSlide(realIndex) {
      this.noticeIndex = realIndex
      viewNotice(this.noticeList[this.noticeIndex].id).then(res => {
        this.noticeData = res.data
        this.visible = true
      })
    },
    goDetail(id) {
      this.visible = false
      this.$router.push(`/systemNotice/${id}`)
    },
    loginOut() {
      // this.Logout()
    },
    changRoute(title, path) {
      this.$router.push(path)
      this.activeBar = title
    },
    changeCategory(category) {
      if (category) {
        this.$router.push('/products/category/' + category)
      } else {
        this.$router.push('/products')
      }
    },
    showRightMenuItem(item) {
      const handle = item.handle
      switch (this.madeInType) {
        case 1: // USA - 全部显示，除了 Kids & Youth Clothing
          return handle !== 'kids_youth_clothing'
        case 2: // UK - 只显示 Men's clothing
          return handle === 'men_s_clothing'
        case 3: // DE - 显示 Home & Living、Men's clothing、Women's Clothing
          return ['home_living', 'men_s_clothing', 'women_s_clothing'].includes(handle)
        case 4: // JP - 只显示 Women's Clothing
          return handle === 'women_s_clothing'
        case 5: // CA - 只显示 Home & Living
          return handle === 'home_living'
        default:
          return false
      }
    },
    changeHandle(category) {
      if (this.madeInType === 1) {
        this.$ls.set('madeInCountry', 'US')
      } else if (this.madeInType === 2) {
        this.$ls.set('madeInCountry', 'UK')
      } else if (this.madeInType === 3) {
        this.$ls.set('madeInCountry', 'DE')
      } else if (this.madeInType === 4) {
        this.$ls.set('madeInCountry', 'JP')
      } else if (this.madeInType === 5) {
        this.$ls.set('madeInCountry', 'CA')
      }
      this.$nextTick(() => {
        this.$router.push('/products/category/' + category)
      })
    },
    changeProductBrand(id) {
      this.$router.push('/products/brand/' + id)
    },
    changeProductTag(productTag) {
      this.$router.push('/products/tag/' + productTag)
    },
    changeLevel(level) {
      this.$router.push('/products/level/' + level)
    },
    changeSpecial(special) {
      this.$router.push('/products/special/' + special)
    },
    goLink(src) {
      window.open(src)
    },
    curChange(value) {
      this.setCur(value)
      Vue.ls.set('cur', value)
      this.GetRate()
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
  },
  watch: {
    $route(to, from) {
      this.select = [to.name]
      this.mobileCss()
    }
  },
  computed: {
    ...mapState({
      info: state => state.user.info,
      cartTotal: state => state.user.cartTotal,
      token: state => state.user.token,
      cur: state => state.user.cur,
      systemNoticePolling: state => state.user.systemNoticePolling,
      favoritesNum: state => state.user.favoritesNum
    }),
    ...mapGetters(['getToken', 'getSearchSource', 'getHotWords', 'getCur'])
  },
  created() {
    if (Vue.ls.get('cur')) {
      this.setCur(Vue.ls.get('cur'))
      this.GetRate()
    }
    this.select = [this.$route.name]
    getFrontendNoticeList({}).then(res => {
      this.noticeList = res.data.data
      console.log('noticeList=======', this.noticeList)
    })
    // 使用缓存获取分类列表
    this.getStockSkuCategoryList()
    this.getSpecialList()
    if (this.getToken) {
      this.getCartData()
      this.GetSystemNoticePolling()
      this.GetFavoritesNum()
    }
    this.mobileCss()

    // 开发环境下暴露清除缓存的方法（方便测试）
    // if (process.env.NODE_ENV === 'development') {
    //   window.clearHomePageCache = this.clearAllCache
    // }
  }
}
</script>

<style lang="less" scoped>
.head_system_notice {
  color: #ffa200;
  background: #f3ece1;
  border: 1px solid #f48900;
  padding: 6px;
  text-align: center;
  img {
    width: 24px;
  }
  cursor: pointer;
}
.notice_detail {
  .title {
    font-size: 20px;
    font-weight: 700;
    color: #333;
  }
  .created_time {
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 20px;
  }
  .autoWrap {
    max-height: 400px;
    overflow-y: auto;
    .ql-editor {
      /deep/img {
        max-width: 100% !important;
      }
    }
    &::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 5px;
    }
    &::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      // -webkit-box-shadow: inset 0 0 5px rgba(6, 6, 13, 0.2);
      background: rgba(6, 6, 13, 0.2);
    }
    &::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      border-radius: 10px;
      background: white;
    }
  }
  .tc {
    margin-top: 10px;
    text-align: center;
  }
}
.adBlock {
  width: 100%;
  img {
    width: 100%;
  }
}
.imgWrap {
  cursor: pointer;
  position: relative;
  .linkA {
    position: absolute;
    z-index: 1;
    &.lt {
      top: 0;
      width: 50%;
      height: 100%;
      left: 0;
    }
    &.rt {
      top: 0;
      width: 50%;
      height: 100%;
      right: 0;
    }
    &.tp {
      top: 0;
      width: 100%;
      height: 54%;
      left: 0;
    }
    &.bt {
      bottom: 0;
      width: 100%;
      height: 46%;
      left: 0;
    }
  }
  img {
    width: 100%;
  }
}
.search-wrap {
  position: relative;
  .popoverBox {
    position: absolute;
    left: 50%;
    top: 38px;
    width: 598px;
    margin-left: -299px;
    padding-top: 10px;
    z-index: 9;
  }
  .popover-body {
    padding: 10px 20px;
    border-radius: 12px;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    background: #ffffff;
    .popTit {
      font-size: 14px;
      color: #333;
    }
    .popWrap {
      margin: 0 -10px;
      .nullWrap {
        padding: 10px 0;
        font-size: 20px;
        color: #ddd;
        text-align: center;
      }
      span {
        float: left;
        margin: 0 10px 10px 10px;
        padding: 0 20px;
        border-radius: 12px;
        line-height: 32px;
        background: #edf2f5;
        cursor: pointer;
      }
    }
  }
}
.search {
  margin-top: -4px;
  margin-right: 6px;
  .ant-input {
    border: none;
    border-bottom: 1px solid #cccccc;
    background: transparent;
    outline: 0;
    &:focus {
      outline: 0;
      box-shadow: none;
    }
  }
}

.header {
  margin: 0 auto;
  width: 1400px;
  // height: 125px;
  height: 106px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // border-bottom: 2px solid #cccccc;
  .logo {
    // width: 170px;
  }
  .leftWrap {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    .search {
      margin-top: -4px;
      margin-right: 6px;
    }
    .cart-sp {
      position: relative;
      cursor: pointer;
      .badge-wrap {
        position: absolute;
        top: -10px;
        right: 10px;
      }
    }
  }
  .tabBar {
    display: flex;
    flex: 1;
    justify-content: center;

    .tabTitle {
      font-size: 20px;
      box-sizing: border-box;
      display: inline-block;
      color: #333333;
      &.on {
        color: #4b9bdf;
      }
    }
    .sass,
    .pod {
      position: relative;
      .podConten {
        display: inline-block;
        right: -2px;
        top: 5px;
        position: absolute;
        background: #ff0000;
        width: 40px;
        text-align: center;
        height: 15px;
        line-height: 15px;
        font-size: 10px;
        font-weight: 300;
        color: #ffffff;
      }
    }
    .sass {
      .podConten {
        width: 50px;
      }
    }
  }
  .rightWrap {
    display: flex;
    flex: 1;
    justify-content: space-between;
    align-items: center;
  }
}
.header-mobile {
  display: none;
  height: 44px;
  background: #ffffff;
  justify-content: space-between;
  align-items: center;
  padding: 10px 17px;
  .h-left {
    display: flex;
    align-items: center;
    > img {
      height: 22px;
      margin-left: 6px;
    }
  }
  i {
    font-size: 24px;
  }
  .anticon-user {
  }
  .anticon-user-add {
    background: #ffa200;
    padding: 4px 12px;
    border-radius: 4px;
    color: white;
    margin-left: 6px;
  }
}
.banner_mobile {
  display: none;
}
@media screen and (max-width: 960px) {
  .header {
    display: none;
  }
  .header-mobile {
    display: flex;
  }
  .banner {
    display: none;
  }
  .banner_mobile {
    display: block;
  }
}
.content {
  width: 100%;
  margin: 0 auto;
  //   padding: 0 362px;
}

.footer {
  width: 1200px;
  padding: 90px 0 60px 0;
  margin: 0 auto;
  background: #ffffff;
  .footerWrap {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .ft-menu-wrap {
    a {
      display: block;
      margin-bottom: 20px;
      font-size: 14px;
      color: #666666;
      line-height: 1;
      &:first-child {
        color: #000000;
        margin-bottom: 30px;
        font-weight: bold;
        font-size: 18px;
        // cursor: default;
      }
    }
  }
  .copyrightWrap {
    font-size: 14px;
    color: #666666;
    background: #ffffff;
    a {
      color: #666666;
      &:hover {
        color: #3699ff;
      }
    }
  }
  .link_icon {
    width: 30px;
    height: 30px;
    text-align: center;
    // line-height: 35px;
    margin-right: 10px;
    cursor: pointer;
  }
}
.footer-mobile {
  display: none;
  padding: 16px;
  text-align: center;
  > img {
    &:nth-child(1) {
      height: 22px;
    }
    &:nth-child(3) {
      height: 30px;
    }
    &:nth-child(5) {
      width: 100%;
      margin-bottom: 12px;
    }
  }
  > p {
    text-align: center;
    font-size: 16px;
    color: #999999;
    margin-top: 12px;
  }
}
@media screen and (max-width: 960px) {
  .footer {
    display: none;
  }
  .footer-mobile {
    display: block;
  }
}
.popover-wrap {
  a {
    display: block;
    margin-bottom: 12px;
    font-size: 14px;
    color: #333;
    line-height: 1;
    &:last-child {
      margin-bottom: 0;
    }
    &:hover {
      color: #3699ff;
    }
  }
  .tc {
    text-align: center;
    .btn {
      display: inline-block;
      padding: 0 20px;
      border-radius: 5px;
      line-height: 32px;
      color: #fff;
      background: #3699ff;
    }
  }
}
.howItWorkWrap {
  display: flex;
  flex-flow: column;
  width: 240px;
  a {
    font-size: 18px;
    font-weight: 500;
    color: #000000;
    padding: 10px;
  }
  a:hover {
    color: #ffa200;
    text-decoration: underline;
  }
}
.hoverItem:hover {
  color: #ffa200;
  text-decoration: underline;
}
</style>
